// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * 멤버십 가입 스타일
 */

.mr-page {
  height: 100dvh;
  background: linear-gradient(135deg, #E8F5E9 0%, #C8E6C9 100%);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* 글로벌 min-height 오버라이드 */
.mr-page button,
.mr-page input,
.mr-page select {
  min-height: auto;
}

/* 헤더 */
.mr-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(8px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  flex-shrink: 0;
}

.mr-header-center {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

.mr-header h1 {
  font-family: 'Jua', sans-serif;
  font-size: 20px;
  color: #2E7D32;
  margin: 0;
}

.mr-header-spacer {
  width: 72px;
}

/* 콘텐츠 */
.mr-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: safe center;
  padding: 16px 20px;
  overflow-y: auto;
}

/* ======================== */
/* 1. 유형 선택 */
/* ======================== */
.mr-type-section {
  width: 100%;
  max-width: 460px;
  margin: auto 0;
  animation: mr-fadeIn 0.3s ease;
}

.mr-type-title {
  font-family: 'Jua', sans-serif;
  font-size: 20px;
  color: #333;
  text-align: center;
  margin: 0 0 16px;
}

.mr-type-cards {
  display: flex;
  gap: 16px;
}

.mr-type-card {
  flex: 1 1;
  background: #fff;
  border: 3px solid #E0E0E0;
  border-radius: 20px;
  padding: 24px 16px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s;
  -webkit-tap-highlight-color: transparent;
}

.mr-type-card:active {
  transform: scale(0.96);
}

.mr-type-family {
  border-color: #A5D6A7;
}

.mr-type-family:active {
  background: #E8F5E9;
  border-color: #4CAF50;
}

.mr-type-friends {
  border-color: #90CAF9;
}

.mr-type-friends:active {
  background: #E3F2FD;
  border-color: #42A5F5;
}

.mr-type-icon {
  font-size: 48px;
  display: block;
  margin-bottom: 8px;
}

.mr-type-card h2 {
  font-family: 'Jua', sans-serif;
  font-size: 22px;
  color: #333;
  margin: 0 0 8px;
}

.mr-type-card p {
  font-size: 14px;
  color: #777;
  line-height: 1.5;
  margin: 0;
}

/* ======================== */
/* 2. 전화번호 입력 */
/* ======================== */
.mr-phone-section {
  width: 100%;
  max-width: 420px;
  margin: auto 0;
  animation: mr-fadeIn 0.3s ease;
}

.mr-mode-badge {
  text-align: center;
  font-family: 'Jua', sans-serif;
  font-size: 16px;
  color: #2E7D32;
  margin-bottom: 8px;
}

.mr-mode-count {
  font-size: 14px;
  color: #777;
}

.mr-phone-card {
  background: rgba(255, 255, 255, 0.8);
  border-radius: 14px;
  padding: 14px;
}

.mr-phone-label {
  font-family: 'Jua', sans-serif;
  font-size: 15px;
  color: #2E7D32;
  margin: 0 0 6px;
  text-align: center;
}

.mr-phone-display {
  padding: 10px;
  background: #fff;
  border: 2px solid #C8E6C9;
  border-radius: 10px;
  font-size: 22px;
  font-weight: 600;
  text-align: center;
  letter-spacing: 2px;
  color: #333;
  margin-bottom: 8px;
}

.mr-phone-error {
  text-align: center;
  color: #C62828;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 8px;
}

/* 넘버패드 */
.mr-numpad {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 5px;
  margin-bottom: 8px;
}

.mr-numpad-btn {
  padding: 8px;
  font-size: 20px;
  font-weight: 600;
  background: #fff;
  border: 2px solid #C8E6C9;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.15s;
  -webkit-tap-highlight-color: transparent;
  -webkit-user-select: none;
          user-select: none;
}

.mr-numpad-btn:active {
  background: #E8F5E9;
  border-color: #4CAF50;
  transform: scale(0.95);
}

.mr-numpad-clear {
  font-size: 14px;
  font-weight: 500;
  color: #C62828;
  background: #FFF5F5;
  border-color: #EF9A9A;
}

.mr-numpad-clear:active {
  background: #FFCDD2;
  border-color: #E57373;
}

.mr-numpad-backspace {
  font-size: 22px;
  color: #666;
  background: #EEEEEE;
  border-color: #BDBDBD;
}

.mr-numpad-backspace:active {
  background: #E0E0E0;
  border-color: #9E9E9E;
}

.mr-phone-btn {
  width: 100%;
  padding: 10px;
  background: linear-gradient(135deg, #66BB6A, #43A047);
  color: #fff;
  border: none;
  border-radius: 14px;
  font-size: 18px;
  font-weight: 700;
  font-family: 'Jua', sans-serif;
  cursor: pointer;
  transition: transform 0.15s;
}

.mr-phone-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.mr-phone-btn:not(:disabled):active {
  transform: scale(0.97);
}

/* ======================== */
/* 3. 번호 확인 */
/* ======================== */
.mr-confirm-section {
  width: 100%;
  max-width: 440px;
  animation: mr-fadeIn 0.3s ease;
}

.mr-confirm-card {
  background: #fff;
  border-radius: 20px;
  padding: 32px 24px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.mr-confirm-icon {
  font-size: 56px;
  display: block;
  margin-bottom: 12px;
}

.mr-confirm-title {
  font-family: 'Jua', sans-serif;
  font-size: 22px;
  color: #333;
  margin: 0 0 8px;
}

.mr-confirm-desc {
  font-size: 15px;
  color: #666;
  line-height: 1.6;
  margin: 0 0 20px;
}

.mr-confirm-phone {
  font-size: 32px;
  font-weight: 700;
  color: #2E7D32;
  letter-spacing: 2px;
  padding: 16px;
  background: #E8F5E9;
  border-radius: 16px;
  border: 3px solid #A5D6A7;
  margin-bottom: 20px;
}

.mr-confirm-buttons {
  display: flex;
  gap: 10px;
}

.mr-btn-fix {
  flex: 1 1;
  padding: 16px;
  background: #FFF3E0;
  color: #E65100;
  border: 2px solid #FFCC80;
  border-radius: 14px;
  font-size: 17px;
  font-weight: 700;
  font-family: 'Jua', sans-serif;
  cursor: pointer;
  transition: transform 0.15s;
}

.mr-btn-fix:active {
  transform: scale(0.97);
}

.mr-btn-register {
  flex: 1 1;
  padding: 16px;
  background: linear-gradient(135deg, #66BB6A, #43A047);
  color: #fff;
  border: none;
  border-radius: 14px;
  font-size: 17px;
  font-weight: 700;
  font-family: 'Jua', sans-serif;
  cursor: pointer;
  transition: transform 0.15s;
}

.mr-btn-register:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.mr-btn-register:not(:disabled):active {
  transform: scale(0.97);
}

/* ======================== */
/* 로딩 */
/* ======================== */
.mr-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  margin-top: 80px;
}

.mr-spinner {
  width: 48px;
  height: 48px;
  border: 4px solid #C8E6C9;
  border-top-color: #4CAF50;
  border-radius: 50%;
  animation: mr-spin 0.8s linear infinite;
}

@keyframes mr-spin {
  to { transform: rotate(360deg); }
}

.mr-loading p {
  font-size: 16px;
  color: #555;
}

/* ======================== */
/* 4. 자녀 추가 (가족) */
/* ======================== */
.mr-children-section {
  width: 100%;
  animation: mr-fadeIn 0.3s ease;
}

/* 좌우 배치: 대표+자녀(좌) | 추가폼+완료(우) */
.mr-children-row {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

.mr-children-left {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.mr-children-right {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.mr-parent-card {
  background: #fff;
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.1);
}

.mr-parent-header {
  display: flex;
  align-items: center;
  gap: 14px;
}

.mr-parent-avatar {
  font-size: 36px;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #E8F5E9;
  border-radius: 50%;
}

.mr-parent-name {
  font-family: 'Jua', sans-serif;
  font-size: 18px;
  color: #333;
  margin: 0 0 2px;
}

.mr-parent-phone {
  font-size: 13px;
  color: #888;
}

.mr-parent-badge {
  margin-left: auto;
  padding: 4px 12px;
  background: #E8F5E9;
  color: #2E7D32;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 700;
}

/* 결과 메시지 */
.mr-result-msg {
  padding: 12px 16px;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 16px;
  animation: mr-fadeIn 0.3s ease;
}

.mr-result-msg.success {
  background: #E8F5E9;
  color: #2E7D32;
}

.mr-result-msg.fail {
  background: #FFEBEE;
  color: #C62828;
}

/* 자녀 목록 */
.mr-child-list-card {
  background: #fff;
  border-radius: 14px;
  padding: 14px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.mr-child-list-title {
  font-family: 'Jua', sans-serif;
  font-size: 16px;
  color: #333;
  margin: 0 0 12px;
}

.mr-child-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
}

.mr-child-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  background: #F9FBE7;
  border-radius: 12px;
  border: 1.5px solid #E8F5E9;
}

.mr-child-avatar {
  width: 40px;
  height: 40px;
  background: #C8E6C9;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Jua', sans-serif;
  font-size: 18px;
  color: #2E7D32;
}

.mr-child-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.mr-child-nickname {
  font-family: 'Jua', sans-serif;
  font-size: 16px;
  color: #333;
}

.mr-child-balance {
  font-size: 13px;
  color: #777;
}

/* 자녀 추가 폼 */
.mr-add-child-form {
  background: #fff;
  border-radius: 14px;
  padding: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.mr-form-title {
  font-family: 'Jua', sans-serif;
  font-size: 17px;
  color: #333;
  margin: 0 0 16px;
  text-align: center;
}

.mr-form-group {
  margin-bottom: 10px;
}

.mr-form-group label {
  display: block;
  font-size: 13px;
  color: #777;
  font-weight: 600;
  margin-bottom: 6px;
}

.mr-form-group input {
  width: 100%;
  padding: 10px 12px;
  border: 2px solid #E0E0E0;
  border-radius: 12px;
  font-size: 16px;
  outline: none;
  transition: border-color 0.2s;
  box-sizing: border-box;
}

.mr-form-group input:focus {
  border-color: #4CAF50;
}

.mr-btn-add-child {
  width: 100%;
  padding: 14px;
  background: linear-gradient(135deg, #66BB6A, #43A047);
  color: #fff;
  border: none;
  border-radius: 14px;
  font-size: 16px;
  font-weight: 700;
  font-family: 'Jua', sans-serif;
  cursor: pointer;
  transition: transform 0.15s;
  margin-top: 8px;
}

.mr-btn-add-child:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.mr-btn-add-child:not(:disabled):active {
  transform: scale(0.97);
}

/* ======================== */
/* 5. 연인/친구 1명 완료 */
/* ======================== */
.mr-friend-done-section {
  width: 100%;
  max-width: 440px;
  animation: mr-fadeIn 0.3s ease;
}

.mr-friend-done-card {
  background: #fff;
  border-radius: 20px;
  padding: 32px 24px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.mr-friend-done-icon {
  font-size: 56px;
  display: block;
  margin-bottom: 16px;
}

.mr-friend-done-count {
  font-size: 16px;
  color: #555;
  margin: 0 0 20px;
}

.mr-friend-done-count strong {
  color: #2E7D32;
  font-size: 20px;
}

.mr-friend-done-buttons {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.mr-btn-next-friend {
  width: 100%;
  padding: 16px;
  background: linear-gradient(135deg, #42A5F5, #1E88E5);
  color: #fff;
  border: none;
  border-radius: 14px;
  font-size: 18px;
  font-weight: 700;
  font-family: 'Jua', sans-serif;
  cursor: pointer;
  transition: transform 0.15s;
}

.mr-btn-next-friend:active {
  transform: scale(0.97);
}

/* 공통 완료 버튼 */
.mr-btn-complete {
  width: 100%;
  padding: 14px;
  background: linear-gradient(135deg, #78909C, #546E7A);
  color: #fff;
  border: none;
  border-radius: 14px;
  font-size: 16px;
  font-weight: 700;
  font-family: 'Jua', sans-serif;
  cursor: pointer;
  transition: transform 0.15s;
  margin-top: 12px;
}

.mr-btn-complete:active {
  transform: scale(0.97);
}

/* 애니메이션 */
@keyframes mr-fadeIn {
  from { opacity: 0; transform: translateY(12px); }
  to { opacity: 1; transform: translateY(0); }
}
`, "",{"version":3,"sources":["webpack://./src/pages/MembershipRegisterPage.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,cAAc;EACd,6DAA6D;EAC7D,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;;;EAGE,gBAAgB;AAClB;;AAEA,OAAO;AACP;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,qCAAqC;EACrC,0BAA0B;EAC1B,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA,QAAQ;AACR;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B,aAAa;AACb,6BAA6B;AAC7B;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,SAAS;AACX;;AAEA,6BAA6B;AAC7B,eAAe;AACf,6BAA6B;AAC7B;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,wCAAwC;EACxC,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qDAAqD;EACrD,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B,aAAa;AACb,6BAA6B;AAC7B;EACE,WAAW;EACX,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,qDAAqD;EACrD,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B,OAAO;AACP,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,6BAA6B;AAC7B,kBAAkB;AAClB,6BAA6B;AAC7B;EACE,WAAW;EACX,8BAA8B;AAChC;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,YAAY;AACZ;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qDAAqD;EACrD,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B,mBAAmB;AACnB,6BAA6B;AAC7B;EACE,WAAW;EACX,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qDAAqD;EACrD,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,aAAa;AACb;EACE,WAAW;EACX,aAAa;EACb,qDAAqD;EACrD,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,UAAU;AACV;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C","sourcesContent":["/**\n * 멤버십 가입 스타일\n */\n\n.mr-page {\n  height: 100dvh;\n  background: linear-gradient(135deg, #E8F5E9 0%, #C8E6C9 100%);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n/* 글로벌 min-height 오버라이드 */\n.mr-page button,\n.mr-page input,\n.mr-page select {\n  min-height: auto;\n}\n\n/* 헤더 */\n.mr-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 16px;\n  background: rgba(255, 255, 255, 0.85);\n  backdrop-filter: blur(8px);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n  flex-shrink: 0;\n}\n\n.mr-header-center {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  -webkit-user-select: none;\n  user-select: none;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.mr-header h1 {\n  font-family: 'Jua', sans-serif;\n  font-size: 20px;\n  color: #2E7D32;\n  margin: 0;\n}\n\n.mr-header-spacer {\n  width: 72px;\n}\n\n/* 콘텐츠 */\n.mr-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: safe center;\n  padding: 16px 20px;\n  overflow-y: auto;\n}\n\n/* ======================== */\n/* 1. 유형 선택 */\n/* ======================== */\n.mr-type-section {\n  width: 100%;\n  max-width: 460px;\n  margin: auto 0;\n  animation: mr-fadeIn 0.3s ease;\n}\n\n.mr-type-title {\n  font-family: 'Jua', sans-serif;\n  font-size: 20px;\n  color: #333;\n  text-align: center;\n  margin: 0 0 16px;\n}\n\n.mr-type-cards {\n  display: flex;\n  gap: 16px;\n}\n\n.mr-type-card {\n  flex: 1;\n  background: #fff;\n  border: 3px solid #E0E0E0;\n  border-radius: 20px;\n  padding: 24px 16px;\n  text-align: center;\n  cursor: pointer;\n  transition: all 0.2s;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.mr-type-card:active {\n  transform: scale(0.96);\n}\n\n.mr-type-family {\n  border-color: #A5D6A7;\n}\n\n.mr-type-family:active {\n  background: #E8F5E9;\n  border-color: #4CAF50;\n}\n\n.mr-type-friends {\n  border-color: #90CAF9;\n}\n\n.mr-type-friends:active {\n  background: #E3F2FD;\n  border-color: #42A5F5;\n}\n\n.mr-type-icon {\n  font-size: 48px;\n  display: block;\n  margin-bottom: 8px;\n}\n\n.mr-type-card h2 {\n  font-family: 'Jua', sans-serif;\n  font-size: 22px;\n  color: #333;\n  margin: 0 0 8px;\n}\n\n.mr-type-card p {\n  font-size: 14px;\n  color: #777;\n  line-height: 1.5;\n  margin: 0;\n}\n\n/* ======================== */\n/* 2. 전화번호 입력 */\n/* ======================== */\n.mr-phone-section {\n  width: 100%;\n  max-width: 420px;\n  margin: auto 0;\n  animation: mr-fadeIn 0.3s ease;\n}\n\n.mr-mode-badge {\n  text-align: center;\n  font-family: 'Jua', sans-serif;\n  font-size: 16px;\n  color: #2E7D32;\n  margin-bottom: 8px;\n}\n\n.mr-mode-count {\n  font-size: 14px;\n  color: #777;\n}\n\n.mr-phone-card {\n  background: rgba(255, 255, 255, 0.8);\n  border-radius: 14px;\n  padding: 14px;\n}\n\n.mr-phone-label {\n  font-family: 'Jua', sans-serif;\n  font-size: 15px;\n  color: #2E7D32;\n  margin: 0 0 6px;\n  text-align: center;\n}\n\n.mr-phone-display {\n  padding: 10px;\n  background: #fff;\n  border: 2px solid #C8E6C9;\n  border-radius: 10px;\n  font-size: 22px;\n  font-weight: 600;\n  text-align: center;\n  letter-spacing: 2px;\n  color: #333;\n  margin-bottom: 8px;\n}\n\n.mr-phone-error {\n  text-align: center;\n  color: #C62828;\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n\n/* 넘버패드 */\n.mr-numpad {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 5px;\n  margin-bottom: 8px;\n}\n\n.mr-numpad-btn {\n  padding: 8px;\n  font-size: 20px;\n  font-weight: 600;\n  background: #fff;\n  border: 2px solid #C8E6C9;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.15s;\n  -webkit-tap-highlight-color: transparent;\n  user-select: none;\n}\n\n.mr-numpad-btn:active {\n  background: #E8F5E9;\n  border-color: #4CAF50;\n  transform: scale(0.95);\n}\n\n.mr-numpad-clear {\n  font-size: 14px;\n  font-weight: 500;\n  color: #C62828;\n  background: #FFF5F5;\n  border-color: #EF9A9A;\n}\n\n.mr-numpad-clear:active {\n  background: #FFCDD2;\n  border-color: #E57373;\n}\n\n.mr-numpad-backspace {\n  font-size: 22px;\n  color: #666;\n  background: #EEEEEE;\n  border-color: #BDBDBD;\n}\n\n.mr-numpad-backspace:active {\n  background: #E0E0E0;\n  border-color: #9E9E9E;\n}\n\n.mr-phone-btn {\n  width: 100%;\n  padding: 10px;\n  background: linear-gradient(135deg, #66BB6A, #43A047);\n  color: #fff;\n  border: none;\n  border-radius: 14px;\n  font-size: 18px;\n  font-weight: 700;\n  font-family: 'Jua', sans-serif;\n  cursor: pointer;\n  transition: transform 0.15s;\n}\n\n.mr-phone-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.mr-phone-btn:not(:disabled):active {\n  transform: scale(0.97);\n}\n\n/* ======================== */\n/* 3. 번호 확인 */\n/* ======================== */\n.mr-confirm-section {\n  width: 100%;\n  max-width: 440px;\n  animation: mr-fadeIn 0.3s ease;\n}\n\n.mr-confirm-card {\n  background: #fff;\n  border-radius: 20px;\n  padding: 32px 24px;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.1);\n  text-align: center;\n}\n\n.mr-confirm-icon {\n  font-size: 56px;\n  display: block;\n  margin-bottom: 12px;\n}\n\n.mr-confirm-title {\n  font-family: 'Jua', sans-serif;\n  font-size: 22px;\n  color: #333;\n  margin: 0 0 8px;\n}\n\n.mr-confirm-desc {\n  font-size: 15px;\n  color: #666;\n  line-height: 1.6;\n  margin: 0 0 20px;\n}\n\n.mr-confirm-phone {\n  font-size: 32px;\n  font-weight: 700;\n  color: #2E7D32;\n  letter-spacing: 2px;\n  padding: 16px;\n  background: #E8F5E9;\n  border-radius: 16px;\n  border: 3px solid #A5D6A7;\n  margin-bottom: 20px;\n}\n\n.mr-confirm-buttons {\n  display: flex;\n  gap: 10px;\n}\n\n.mr-btn-fix {\n  flex: 1;\n  padding: 16px;\n  background: #FFF3E0;\n  color: #E65100;\n  border: 2px solid #FFCC80;\n  border-radius: 14px;\n  font-size: 17px;\n  font-weight: 700;\n  font-family: 'Jua', sans-serif;\n  cursor: pointer;\n  transition: transform 0.15s;\n}\n\n.mr-btn-fix:active {\n  transform: scale(0.97);\n}\n\n.mr-btn-register {\n  flex: 1;\n  padding: 16px;\n  background: linear-gradient(135deg, #66BB6A, #43A047);\n  color: #fff;\n  border: none;\n  border-radius: 14px;\n  font-size: 17px;\n  font-weight: 700;\n  font-family: 'Jua', sans-serif;\n  cursor: pointer;\n  transition: transform 0.15s;\n}\n\n.mr-btn-register:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.mr-btn-register:not(:disabled):active {\n  transform: scale(0.97);\n}\n\n/* ======================== */\n/* 로딩 */\n/* ======================== */\n.mr-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  margin-top: 80px;\n}\n\n.mr-spinner {\n  width: 48px;\n  height: 48px;\n  border: 4px solid #C8E6C9;\n  border-top-color: #4CAF50;\n  border-radius: 50%;\n  animation: mr-spin 0.8s linear infinite;\n}\n\n@keyframes mr-spin {\n  to { transform: rotate(360deg); }\n}\n\n.mr-loading p {\n  font-size: 16px;\n  color: #555;\n}\n\n/* ======================== */\n/* 4. 자녀 추가 (가족) */\n/* ======================== */\n.mr-children-section {\n  width: 100%;\n  animation: mr-fadeIn 0.3s ease;\n}\n\n/* 좌우 배치: 대표+자녀(좌) | 추가폼+완료(우) */\n.mr-children-row {\n  display: flex;\n  gap: 20px;\n  align-items: flex-start;\n}\n\n.mr-children-left {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.mr-children-right {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.mr-parent-card {\n  background: #fff;\n  border-radius: 16px;\n  padding: 16px;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.1);\n}\n\n.mr-parent-header {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n\n.mr-parent-avatar {\n  font-size: 36px;\n  width: 50px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #E8F5E9;\n  border-radius: 50%;\n}\n\n.mr-parent-name {\n  font-family: 'Jua', sans-serif;\n  font-size: 18px;\n  color: #333;\n  margin: 0 0 2px;\n}\n\n.mr-parent-phone {\n  font-size: 13px;\n  color: #888;\n}\n\n.mr-parent-badge {\n  margin-left: auto;\n  padding: 4px 12px;\n  background: #E8F5E9;\n  color: #2E7D32;\n  border-radius: 20px;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n/* 결과 메시지 */\n.mr-result-msg {\n  padding: 12px 16px;\n  border-radius: 12px;\n  font-size: 15px;\n  font-weight: 600;\n  text-align: center;\n  margin-bottom: 16px;\n  animation: mr-fadeIn 0.3s ease;\n}\n\n.mr-result-msg.success {\n  background: #E8F5E9;\n  color: #2E7D32;\n}\n\n.mr-result-msg.fail {\n  background: #FFEBEE;\n  color: #C62828;\n}\n\n/* 자녀 목록 */\n.mr-child-list-card {\n  background: #fff;\n  border-radius: 14px;\n  padding: 14px;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);\n}\n\n.mr-child-list-title {\n  font-family: 'Jua', sans-serif;\n  font-size: 16px;\n  color: #333;\n  margin: 0 0 12px;\n}\n\n.mr-child-list {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.mr-child-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 14px;\n  background: #F9FBE7;\n  border-radius: 12px;\n  border: 1.5px solid #E8F5E9;\n}\n\n.mr-child-avatar {\n  width: 40px;\n  height: 40px;\n  background: #C8E6C9;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: 'Jua', sans-serif;\n  font-size: 18px;\n  color: #2E7D32;\n}\n\n.mr-child-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.mr-child-nickname {\n  font-family: 'Jua', sans-serif;\n  font-size: 16px;\n  color: #333;\n}\n\n.mr-child-balance {\n  font-size: 13px;\n  color: #777;\n}\n\n/* 자녀 추가 폼 */\n.mr-add-child-form {\n  background: #fff;\n  border-radius: 14px;\n  padding: 16px;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);\n}\n\n.mr-form-title {\n  font-family: 'Jua', sans-serif;\n  font-size: 17px;\n  color: #333;\n  margin: 0 0 16px;\n  text-align: center;\n}\n\n.mr-form-group {\n  margin-bottom: 10px;\n}\n\n.mr-form-group label {\n  display: block;\n  font-size: 13px;\n  color: #777;\n  font-weight: 600;\n  margin-bottom: 6px;\n}\n\n.mr-form-group input {\n  width: 100%;\n  padding: 10px 12px;\n  border: 2px solid #E0E0E0;\n  border-radius: 12px;\n  font-size: 16px;\n  outline: none;\n  transition: border-color 0.2s;\n  box-sizing: border-box;\n}\n\n.mr-form-group input:focus {\n  border-color: #4CAF50;\n}\n\n.mr-btn-add-child {\n  width: 100%;\n  padding: 14px;\n  background: linear-gradient(135deg, #66BB6A, #43A047);\n  color: #fff;\n  border: none;\n  border-radius: 14px;\n  font-size: 16px;\n  font-weight: 700;\n  font-family: 'Jua', sans-serif;\n  cursor: pointer;\n  transition: transform 0.15s;\n  margin-top: 8px;\n}\n\n.mr-btn-add-child:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.mr-btn-add-child:not(:disabled):active {\n  transform: scale(0.97);\n}\n\n/* ======================== */\n/* 5. 연인/친구 1명 완료 */\n/* ======================== */\n.mr-friend-done-section {\n  width: 100%;\n  max-width: 440px;\n  animation: mr-fadeIn 0.3s ease;\n}\n\n.mr-friend-done-card {\n  background: #fff;\n  border-radius: 20px;\n  padding: 32px 24px;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.1);\n  text-align: center;\n}\n\n.mr-friend-done-icon {\n  font-size: 56px;\n  display: block;\n  margin-bottom: 16px;\n}\n\n.mr-friend-done-count {\n  font-size: 16px;\n  color: #555;\n  margin: 0 0 20px;\n}\n\n.mr-friend-done-count strong {\n  color: #2E7D32;\n  font-size: 20px;\n}\n\n.mr-friend-done-buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.mr-btn-next-friend {\n  width: 100%;\n  padding: 16px;\n  background: linear-gradient(135deg, #42A5F5, #1E88E5);\n  color: #fff;\n  border: none;\n  border-radius: 14px;\n  font-size: 18px;\n  font-weight: 700;\n  font-family: 'Jua', sans-serif;\n  cursor: pointer;\n  transition: transform 0.15s;\n}\n\n.mr-btn-next-friend:active {\n  transform: scale(0.97);\n}\n\n/* 공통 완료 버튼 */\n.mr-btn-complete {\n  width: 100%;\n  padding: 14px;\n  background: linear-gradient(135deg, #78909C, #546E7A);\n  color: #fff;\n  border: none;\n  border-radius: 14px;\n  font-size: 16px;\n  font-weight: 700;\n  font-family: 'Jua', sans-serif;\n  cursor: pointer;\n  transition: transform 0.15s;\n  margin-top: 12px;\n}\n\n.mr-btn-complete:active {\n  transform: scale(0.97);\n}\n\n/* 애니메이션 */\n@keyframes mr-fadeIn {\n  from { opacity: 0; transform: translateY(12px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
